import { t } from "i18next";
import { useEffect } from "react";
import { useCookies } from "react-cookie";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { ButtonContainer, OkBtn, OkWhiteBtn } from "routes/Checkout/styles";
import { sendULFEvent, setModal } from "state/config-slice";
import { offersState, selectOfferByName } from "state/offers-slice";
import { AppDispatch } from "state/reducers-combiner";
import { ErrorCode } from "types/CustomError";
import Offer from "types/Offer";
import OfferPage, { HelpLink } from "types/OfferPage";
import { ULFEvents } from "types/ULF";

const useErrorCode = () => {
  const { name } = useParams<{ name?: string }>();
  const dispatch: AppDispatch = useDispatch();
  const [cookies, , removeCookies] = useCookies();
  const offers = useSelector(offersState);
  const navigate = useNavigate();
  const selectedOffer: Offer = useSelector(selectOfferByName(name));

  const offerPage = selectedOffer?.marketplaceInfo?.pages["active"] as OfferPage; // || null;
  const helpLinksGoTo = offerPage?.helpLinks?.[3] as HelpLink;

  useEffect(() => {
    if (!cookies.ERRORCODE) return;

    switch (cookies.ERRORCODE) {
      case ErrorCode.EXISTINGACCOUNT:
        if (offers.offersList.length > 0) {
          dispatch(
            setModal({
              showModal: true,
              errorModal: true,
              size: "big",
              title: t("Error!"),
              description: t("8001 Error Code Message"),
              customButtons: (
                <ButtonContainer>
                  <OkBtn
                    id="go-to-amazon"
                    title={helpLinksGoTo?.label}
                    onClick={() => {
                      removeCookies("ERRORCODE");
                      dispatch(setModal({ showModal: false }));
                      window.location.assign(helpLinksGoTo?.url as string);
                    }}
                  />
                  <OkWhiteBtn
                    id="error-page-back"
                    onClick={() => {
                      navigate("/");
                      dispatch(
                        sendULFEvent({
                          page: window.location.pathname,
                          "event-name": ULFEvents.REDIRECT_TO_HOME_PAGE,
                          source: cookies.SOURCE,
                          isTrackingAllowed: cookies.SUBSCRIPTIONPLUS_TRACKING || false,
                        }),
                      );

                      removeCookies("ERRORCODE");
                      dispatch(setModal({ showModal: false }));
                    }}
                    title={t("Back to homepage")}
                  />
                </ButtonContainer>
              ),
            }),
          );
        }

        break;

      case ErrorCode.USERNOTVALID:
        navigate("/not-eligible-user");

        break;

      default:
        console.error("Unknown error code");
    }
  }, [
    offers.offersList.length,
    cookies,
    dispatch,
    navigate,
    removeCookies,
    offerPage?.helpLinks,
    helpLinksGoTo?.label,
    helpLinksGoTo?.url,
  ]);

  return;
};

export default useErrorCode;
